import { useDragLayer } from "react-dnd";
import {
  DND_ITEM_TYPES,
  DraggedDesignItem,
  DraggedProjectItem,
} from "../../../constant/dnd.constant";
import { DesignDragPreview } from "./DesignDragPreview";
import { ProjectNavItemDragPreview } from "../../../containers/LeftNavigation/TeamProjects/ProjectNavLink/ProjectDragPreview";
import { ProjectCardDragPreview } from "../../ProjectCard/ProjectCardDragPreview";
import { CSSProperties } from "react";

const layerStyles: CSSProperties = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 10000,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
};

function getItemStyles(
  currentOffset: { x: number; y: number } | null
): CSSProperties {
  if (!currentOffset) {
    return {
      display: "none",
    };
  }

  const { x, y } = currentOffset;
  const offsetY = -24;
  const transform = `translate(${x}px, ${y + offsetY}px)`;

  return {
    transform,
    WebkitTransform: transform,
  };
}

export const CustomDragLayer = () => {
  const { itemType, isDragging, item, currentOffset } = useDragLayer(
    (monitor) => ({
      item: monitor.getItem() as DraggedDesignItem | DraggedProjectItem,
      itemType: monitor.getItemType(),
      currentOffset: monitor.getClientOffset(),
      isDragging: monitor.isDragging(),
    })
  );

  if (!isDragging) {
    return null;
  }

  if (!item) {
    return null;
  }

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(currentOffset)}>
        {itemType === DND_ITEM_TYPES.DESIGN_CARD && (
          <DesignDragPreview
            designName={(item as DraggedDesignItem).designName}
            firstImageUrl={(item as DraggedDesignItem).firstImageUrl}
            secondImageUrl={(item as DraggedDesignItem).secondImageUrl}
          />
        )}
        {itemType === DND_ITEM_TYPES.PROJECT &&
          (item as DraggedProjectItem).source === "navlink" && (
            <ProjectNavItemDragPreview
              projectName={(item as DraggedProjectItem).projectName}
            />
          )}
        {itemType === DND_ITEM_TYPES.PROJECT &&
          (item as DraggedProjectItem).source === "card" && (
            <ProjectCardDragPreview
              projectName={(item as DraggedProjectItem).projectName}
              designs={(item as DraggedProjectItem).designs}
            />
          )}
      </div>
    </div>
  );
};
